<template>
    <div class="container-fluid">
        <v-row justify="center">
            <v-col md="12" class="text-center mt-5">
                <img
                    src="@/assets/images/VectorLogo.png"
                    style="max-width:350px; width: calc(100% - 2rem); margin: 0 1rem;"
                    ref="imgTop"
                />
                <h1 style="font-weight:300" class="mb0 text-h5 text-sm-h4">
                    {{ $tc("membershipRegistration.title") }}
                </h1>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <v-row>
                    <v-col class="py-4">
                        <v-row>
                            <v-col style="line-height: 20px; padding: 5% 5% 0% 5%;">
                                <p class="text-h5 text-danger pb-3">
                                    {{$t("registration.membership.cancelled_registration_title")}} 
                                </p>
                                <p>
                                    {{$t("registration.membership.cancelled_registration_description_1")}} 
                                </p>
                                <p>
                                    {{$t("registration.membership.cancelled_registration_description_2")}} 
                                </p>
                                <p>
                                    {{$t("registration.membership.cancelled_registration_description_3")}} 
                                </p>                                
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
    </div>
</template>

<script>
import {
  VRow,
  VCol
} from "vuetify/lib";
export default {
    name: "CanceledMembership",
    components: {
        VRow,
        VCol,
    }
}
</script>

<style scoped>
.text-danger{
    color: #ff0000;
}
</style>